// extracted by css-extract-rspack-plugin
export default {"Box_0":"FilterInputWrapper-module__Box_0__ZqVVe","Box_1":"FilterInputWrapper-module__Box_1__gaU7c"};